import { defaultIconProps, IconProps } from './IconProps';

export const IconPlaySimple: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M1.16663 1.5L12.8333 9L1.16663 16.5V1.5Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconPlaySimple.defaultProps = defaultIconProps;
